module.exports = __webpack_public_path__ + "img/ic24AccountGrey.1e3cc8f5.svg";